(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-video-strip"] && !Shopify.designMode) return;
  try {
    (() => {
      function initializeStrip(strip) {
        if (strip.dataset.initialized === 'true') return;
        const cards = Array.from(strip.querySelectorAll('[data-video-card]'));
        const previewCards = cards.filter((card) => card.dataset.previewSrc?.trim());
        const modal = strip.querySelector('[data-video-modal]');
        const modalInner = strip.querySelector('[data-video-modal-inner]');
        if (!cards.length || !modal || !modalInner) return;
        strip.dataset.initialized = 'true';

        const controller = new AbortController();
        const listenerOptions = { signal: controller.signal };
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection;
        const defaultModalLabel = modal.getAttribute('aria-label');
        let activeIndex = 0;
        let activeVideo = null;
        let rotationTimer = null;
        let isVisible = false;
        let autoplayBlocked = false;
        let returnFocus = null;
        let htmlWasLocked = false;
        let bodyWasLocked = false;

        function clearTimer() {
          window.clearTimeout(rotationTimer);
          rotationTimer = null;
        }

        function releaseVideo(video) {
          if (!video) return;
          video.pause();
          video.removeAttribute('src');
          video.load();
          video.remove();
        }

        function stopRotation() {
          clearTimer();
          const previousVideo = activeVideo;
          activeVideo = null;
          releaseVideo(previousVideo);
          cards.forEach((card) => card.classList.remove('is-active', 'is-playing'));
        }

        function canRotate() {
          return previewCards.length > 0 && strip.isConnected && isVisible && !document.hidden && !modal.open &&
            !reducedMotion.matches && !connection?.saveData && !autoplayBlocked;
        }

        function nextPreview(video) {
          if (activeVideo !== video || !canRotate()) return;
          activeIndex = (activeIndex + 1) % previewCards.length;
          mountPreview();
        }

        function mountPreview() {
          stopRotation();
          if (!canRotate()) return;
          const card = previewCards[activeIndex];
          const slot = card.querySelector('[data-video-slot]');
          if (!slot || !card.dataset.previewSrc) return;

          const video = document.createElement('video');
          video.className = 'pdp-video-strip__preview';
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.preload = 'none';
          video.disablePictureInPicture = true;
          video.tabIndex = -1;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('aria-hidden', 'true');

          video.addEventListener('playing', () => {
            if (activeVideo !== video || !canRotate()) return;
            card.classList.add('is-playing');
            if (rotationTimer === null) {
              rotationTimer = window.setTimeout(() => nextPreview(video), 5000);
            }
          });
          video.addEventListener('ended', () => nextPreview(video));
          video.addEventListener('timeupdate', () => {
            if (video.currentTime >= 5) nextPreview(video);
          });
          video.addEventListener('error', () => {
            if (activeVideo !== video) return;
            autoplayBlocked = true;
            stopRotation();
          });

          activeVideo = video;
          video.src = card.dataset.previewSrc;
          slot.appendChild(video);
          card.classList.add('is-active');
          video.play().catch(() => {
            if (activeVideo !== video) return;
            autoplayBlocked = true;
            stopRotation();
          });
        }

        function syncRotation() {
          if (canRotate()) {
            if (!activeVideo) mountPreview();
          } else {
            stopRotation();
          }
        }

        function closeModal(restoreFocus = true) {
          if (!modal.open) return;
          releaseVideo(modalInner.querySelector('video'));
          modal.close();
          modal.hidden = true;
          if (!htmlWasLocked) document.documentElement.classList.remove('overflow-hidden');
          if (!bodyWasLocked) document.body.classList.remove('overflow-hidden');
          if (restoreFocus && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
          returnFocus = null;
          syncRotation();
        }

        function openModal(card) {
          const fullSrc = card.dataset.fullSrc;
          if (!fullSrc || modal.open) return;
          stopRotation();
          returnFocus = card;
          htmlWasLocked = document.documentElement.classList.contains('overflow-hidden');
          bodyWasLocked = document.body.classList.contains('overflow-hidden');
          modal.setAttribute('aria-label', card.dataset.caption || defaultModalLabel);
          modal.hidden = false;
          modal.showModal();
          document.documentElement.classList.add('overflow-hidden');
          document.body.classList.add('overflow-hidden');

          const video = document.createElement('video');
          video.className = 'pdp-video-strip__modal-video';
          video.controls = true;
          video.playsInline = true;
          video.preload = 'none';
          video.setAttribute('playsinline', '');
          video.src = fullSrc;
          modalInner.appendChild(video);
          modal.querySelector('button[data-video-close]').focus({ preventScroll: true });
          video.play().catch(() => {});
        }

        cards.forEach((card) => {
          card.addEventListener('click', () => openModal(card), listenerOptions);
        });
        modal.querySelectorAll('[data-video-close]').forEach((button) => {
          button.addEventListener('click', () => closeModal(), listenerOptions);
        });
        modal.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeModal();
        }, listenerOptions);
        document.addEventListener('visibilitychange', () => {
          syncRotation();
          if (document.hidden) modalInner.querySelector('video')?.pause();
        }, listenerOptions);
        reducedMotion.addEventListener('change', syncRotation, listenerOptions);
        connection?.addEventListener('change', syncRotation, listenerOptions);
        window.addEventListener('pagehide', stopRotation, listenerOptions);
        window.addEventListener('pageshow', syncRotation, listenerOptions);

        const observer = new IntersectionObserver((entries) => {
          isVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.25);
          syncRotation();
        }, { threshold: [0, 0.25], rootMargin: '0px' });
        observer.observe(strip.querySelector('.pdp-video-strip__grid'));

        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(strip)) return;
          isVisible = false;
          closeModal(false);
          stopRotation();
          observer.disconnect();
          controller.abort();
          delete strip.dataset.initialized;
        }, listenerOptions);
      }

      function initializeStrips(root = document) {
        root.querySelectorAll('[data-pdp-video-strip]').forEach(initializeStrip);
      }

      initializeStrips();
      document.addEventListener('shopify:section:load', (event) => initializeStrips(event.target));
    })();
  } catch(e) { console.error(e); }
})();

})();
